/**
 * 批量保存到工作空间 - 默认选择前100条填入
 */
export const DEFAULT_SELECTION = 100

/**
 * 批量保存到工作空间 - folder上限2w
 */
export const BATCH_SAVE_FOLDER_LIMIT = 20000
